if (!customElements.get("bfcm25-timeline")) {
  customElements.define("bfcm25-timeline", class Bfcm25Timeline extends HTMLElement {
    constructor() {
      super();
      this.copyBtn = this.querySelector('.bfcm25-timeline-block-code-copy');
      this.copyLabel = this.querySelector('.bfcm25-timeline-block-code-copy').textContent;
      this.code = this.querySelector('.bfcm25-timeline-block-code').textContent.trim();

      this.jumpEl = this.querySelectorAll('[data-jump-target]');

      this.helpContainer = this.querySelector('.bfcm25-timeline-help-container');
    }
    connectedCallback() {
      this.copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(this.code).then(() => {
          this.copyBtn.textContent = '✔';
          setTimeout(() => {
            this.copyBtn.textContent = this.copyLabel;
          }, 3000);
        })
      });

      this.jumpEl.forEach((item) => {
        item.addEventListener('click', () => {
          const target = item.dataset.jumpTarget;
          const targetEl = document.getElementById(target);
          if (targetEl) {
            targetEl.scrollIntoView({ behavior: 'smooth' });
          }
        })
      })

      if (this.helpContainer) {
        const helpOpenBtn = this.querySelector('.bfcm25-timeline-help-icon');
        const helpDialog = this.querySelector('.bfcm25-timeline-help-dialog');
        const closeBtn = this.querySelector('.bfcm25-timeline-help-dialog-close');

        // 确保元素存在
        if (!helpOpenBtn || !helpDialog || !closeBtn) return;

        // 封装关闭逻辑，减少重复代码
        const closeHelpDialog = () => {
          // console.log("关闭");
          helpDialog.classList.remove('visible');
          document.body.classList.remove('timeline-help-visible');
        };

        // 打开帮助弹窗
        helpOpenBtn.addEventListener('click', () => {
          // console.log("打开");
          helpDialog.classList.toggle('visible');
          document.body.classList.toggle('timeline-help-visible');
        });

        // 点击关闭按钮关闭
        closeBtn.addEventListener('click', closeHelpDialog);

        // 点击遮罩层关闭
        helpDialog.addEventListener('click', (e) => {
          if (e.target === helpDialog) closeHelpDialog();
        });
      }

    }
  })
}
